function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { createStyles, rem } from '@mantine/styles';
var useStyles = createStyles(function(_theme, param) {
    var orientation = param.orientation, buttonBorderWidth = param.buttonBorderWidth;
    var _obj, _obj1, _obj2, _obj3;
    return {
        root: {
            display: "flex",
            flexDirection: orientation === "vertical" ? "column" : "row",
            "& [data-button]": {
                "&:first-of-type:not(:last-of-type)": (_obj = {
                    borderBottomRightRadius: 0
                }, _define_property(_obj, orientation === "vertical" ? "borderBottomLeftRadius" : "borderTopRightRadius", 0), _define_property(_obj, orientation === "vertical" ? "borderBottomWidth" : "borderRightWidth", "calc(".concat(rem(buttonBorderWidth), " / 2)")), _obj),
                "&:last-of-type:not(:first-of-type)": (_obj1 = {
                    borderTopLeftRadius: 0
                }, _define_property(_obj1, orientation === "vertical" ? "borderTopRightRadius" : "borderBottomLeftRadius", 0), _define_property(_obj1, orientation === "vertical" ? "borderTopWidth" : "borderLeftWidth", "calc(".concat(rem(buttonBorderWidth), " / 2)")), _obj1),
                "&:not(:first-of-type):not(:last-of-type)": (_obj2 = {
                    borderRadius: 0
                }, _define_property(_obj2, orientation === "vertical" ? "borderTopWidth" : "borderLeftWidth", "calc(".concat(rem(buttonBorderWidth), " / 2)")), _define_property(_obj2, orientation === "vertical" ? "borderBottomWidth" : "borderRightWidth", "calc(".concat(rem(buttonBorderWidth), " / 2)")), _obj2),
                "& + [data-button]": (_obj3 = {}, _define_property(_obj3, orientation === "vertical" ? "marginTop" : "marginLeft", "calc(".concat(buttonBorderWidth, " * -1)")), _define_property(_obj3, "@media (min-resolution: 192dpi)", _define_property({}, orientation === "vertical" ? "marginTop" : "marginLeft", 0)), _obj3)
            }
        }
    };
});
export default useStyles; //# sourceMappingURL=ButtonGroup.styles.js.map
